import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Box, Container, Typography, Skeleton, Stack } from "@mui/material";
import { getPrivacyPolicy } from "../../services/PrivacyPolicyService";

const extractBody = (html) => {
  const match = html?.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
  return match ? match[1] : html;
};

const PrivacyPolicy = () => {
  const { data: htmlContent, isLoading } = useQuery({
    queryKey: ["privacyPolicy"],
    queryFn: getPrivacyPolicy,
  });

  if (isLoading) {
    return (
      <Container sx={{ py: { xs: 4, md: 6 } }}>
        <Skeleton variant="text" height={50} width="50%" />
        <Stack spacing={2} mt={3}>
          {[...Array(8)].map((_, i) => (
            <Skeleton key={i} variant="text" height={24} width={`${80 + (i % 3) * 7}%`} />
          ))}
        </Stack>
      </Container>
    );
  }

  if (!htmlContent) {
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <Typography>No privacy policy data found.</Typography>
      </Box>
    );
  }

  return (
    <Container sx={{ py: { xs: 4, md: 6 } }}>
      <Box dangerouslySetInnerHTML={{ __html: extractBody(htmlContent) }} />
    </Container>
  );
};

export default PrivacyPolicy;
